<template>
  <div class="activity" v-if="load">
    <div class="banner">
      <img :src="banner.cover" alt />
    </div>

    <div v-for="(item,index) in list" :key="index">
      <!-- 3 -->
      <div class="news" v-if="index % 2 == 0">
        <div
          class="paragraph clearfix paragraph--type--paragraph-view paragraph--view-mode--default"
        >
          <div
            class="field field--name-field-paragraph-block field--type-block-field field--label-hidden field__items"
          >
            <div class="field__item">
              <div class="news-run">
                <article
                  role="article"
                  about
                  class="decoration clearfix news-run-wide news-run row collapse crop-top"
                >
                  <div
                    class="columns small-12 large-7 xlarge-8 xxlarge-8 xxxlarge-8"
                    aria-hidden="true"
                  >
                    <div
                      class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
                    >
                      <article class="view-mode-captionless-medium media media-image">
                        <div
                          class="field field--name-image field--type-image field--label-hidden field__item"
                        >
                          <img :src="item.cover" alt typeof="foaf:Image" />
                        </div>
                      </article>
                    </div>
                  </div>
                  <div class="columns small-12 large-5 xlarge-4 xxlarge-4 xxxlarge-4">
                    <div class="content row collapse">
                      <div class="news-category">
                        <a href="javascript:;">业务活动</a>
                      </div>
                      <a :href="`/activityDetails?id=${item.id}`" class="padme">
                        <div
                          class="columns small-12 medium-6 large-12 xlarge-12 xxlarge-12 xxxlarge-12"
                        >
                          <h2>
                            <span>{{item.title}}</span>
                            <span class="show-for-sr">.</span>
                          </h2>
                        </div>
                        <div
                          class="columns small-12 medium-6 large-12 xlarge-12 xxlarge-12 xxxlarge-12"
                        >
                          <p>{{item.brief}}</p>
                          <div class="readmore" aria-hidden="true">查看全文</div>
                        </div>
                      </a>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 2 -->
      <div class="news clearfix" v-if="index % 2 !== 0">
        <div
          class="paragraph clearfix paragraph--type--paragraph-view paragraph--view-mode--default"
        >
          <div
            class="field field--name-field-paragraph-block field--type-block-field field--label-hidden field__items"
          >
            <div class="field__item">
              <div class="news-run">
                <article
                  role="article"
                  about="/news/2020/07/23/preventing-next-pandemic"
                  class="clearfix news-run-wide news-run row collapse crop-top"
                >
                  <div class="columns small-12 large-5 xlarge-4 xxlarge-4 xxxlarge-4">
                    <div class="content row collapse">
                      <div class="news-category">
                        <a href="javascript:;">业务活动</a>
                      </div>
                      <a :href="`/activityDetails?id=${item.id}`" class="padme">
                        <div
                          class="columns small-12 medium-6 large-12 xlarge-12 xxlarge-12 xxxlarge-12"
                        >
                          <h2>
                            <span>{{item.title}}</span>
                            <span class="show-for-sr">.</span>
                          </h2>
                        </div>
                        <div
                          class="columns small-12 medium-6 large-12 xlarge-12 xxlarge-12xxxlarge-12"
                        >
                          <p>{{item.brief}}</p>
                          <div class="readmore" aria-hidden="true">查看全文</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    class="columns small-12 large-7 xlarge-8 xxlarge-8 xxxlarge-8"
                    aria-hidden="true"
                  >
                    <div
                      class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
                    >
                      <article class="view-mode-captionless-medium media media-image">
                        <div
                          class="field field--name-image field--type-image field--label-hidden field__item"
                        >
                          <img :src="item.cover" alt typeof="foaf:Image" />
                        </div>
                      </article>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div class="page">
      <a-pagination :default-current="Number(cur_page)" :total="total" @change="checkPage" />
    </div>
  </div>
</template>

<script>
import { ActivityList } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      load: false,
      banner: null,
      list: null,
      cur_page: this.$route.query.page || 1,
      total_page: 1,
    };
  },
  computed: {},
  watch: {},
  methods: {
    checkPage(index) {
      window.location.href = `/activity?page=${index}`;
    },
  },
  created() {
    ActivityList(
      {
        page: this.$route.query.page,
      },
      (res) => {
        this.$emit("complete", true);
        this.load = true;
        if (res.code == 0) {
          this.banner = res.data.banner;
          this.list = res.data.list.list;
          this.total_page = res.data.list.total_page;
          this.total_page = res.data.list.total_page;
          this.total = res.data.list.total;
        }
      }
    );
  },
  mounted() {
    document.getElementById("activity-top-action").classList.add("is-active");
  },
};
</script>
<style lang='less' scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
    height: 43vw;
  }
}
.pager {
  margin-top: 2rem;
}
.page {
  text-align: center;
  margin: 2rem 0;
}
@media print, screen and (max-width: 40em) {
  .news-category {
    display: none;
  }
  .decoration {
    display: flex;
    flex-direction: column-reverse;
  }
}
</style>